var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDependency(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bulk/grid-eraser"
  }, /*#__PURE__*/React.createElement("g", {
    id: "grid-eraser"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.78865 0.532227V8.05724H0.251953V7.26392C0.251953 3.05225 2.7603 0.543905 6.97196 0.543905H7.78865V0.532227Z",
    fill: "#7C7C7C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M23.3981 7.2522C23.3981 7.69553 23.0365 8.04552 22.6048 8.04552H15.8965V0.520508H16.6782C20.3882 0.532174 23.3981 3.5422 23.3981 7.2522Z",
    fill: "#7C7C7C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M7.78869 16.1416V22.8616C7.78869 23.3049 7.42699 23.6549 6.99533 23.6549H6.98368C3.27368 23.6549 0.263672 20.6449 0.263672 16.9349V16.1416H7.78869Z",
    fill: "#7C7C7C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    opacity: 0.4,
    d: "M7.80033 8.0459H0.263672V16.1426H7.80033V8.0459Z",
    fill: "#7C7C7C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M15.8857 8.0459V15.3492C15.8857 15.7926 15.524 16.1426 15.0924 16.1426H7.78906V8.0459H15.8857Z",
    fill: "#7C7C7C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    opacity: 0.4,
    d: "M15.8857 0.532227H7.78906V8.05724H15.8857V0.532227Z",
    fill: "#7C7C7C"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    opacity: 0.4,
    d: "M21.1007 22.1498L18.884 24.3781C18.2774 24.9847 17.2741 24.9847 16.6441 24.3781L14.8007 22.5231C14.194 21.9048 14.194 20.9131 14.8007 20.2831L17.029 18.0781L21.1007 22.1498Z",
    fill: "#7C7C7C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M24.3793 18.884L21.101 22.1506L17.0293 18.079L20.2959 14.789C20.9143 14.1823 21.9176 14.1823 22.536 14.789L24.3793 16.6439C24.9859 17.2623 24.9859 18.2773 24.3793 18.884Z",
    fill: "#7C7C7C"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDependency);
export default __webpack_public_path__ + "static/media/dependency.d4b7f9189453dee2433648a3fc242f6f.svg";
export { ForwardRef as ReactComponent };